/*
 * Where a Book plan step goes, when a reader wants to see it for themselves.
 *
 * Its own module since 31 Aug 2026, so `step-screens.test.ts` can check every destination against
 * the route manifest without importing the flyout — which would pull React, the router and the
 * design system into a test about a table of strings.
 */

/**
 * Where a plan step goes, when a reader wants to see it for themselves.
 *
 * *"An assistant for the logged-in user to help find and do things"* — this is the "do" half, and it
 * is derived in the browser from the interpretation rather than returned by the server. The mapping
 * from a read route to a screen is a fact about **this app**; asking the server for it would put
 * `route-manifest.ts`'s vocabulary behind an API, and a second answer to "where does this live"
 * is a second thing to keep in step.
 *
 * A step with no entry here shows as a chip without a link, which is the honest state: it was
 * looked at, and there is no single screen that is it.
 */
export const STEP_SCREENS: Readonly<Record<string, string>> = {
  'clients.job.list': '/jobs',
  'clients.client.list': '/clients',
  'pipeline.application.list': '/pipeline',
  'pipeline.interview.list': '/interviews',
  'pipeline.submission.list': '/pipeline',
  /*
   * `/search`, not `/candidates/search`. The latter is not a route in this app and never has been,
   * and the chip linked to it since the day it was written — nothing checks a hand-written map of
   * paths, so it failed silently on click. `step-screens.test.ts` now checks every entry against the
   * route manifest, which is the same list the router is built from.
   */
  'candidates.candidate.search': '/search',
  'candidates.talent_pool.list': '/candidates/pools',
};
